// Main entry point for the Garden Planner Vite application
import './styles/main.css';

// Import Firebase modules
import './modules/firebase-config.js';
import './modules/auth.js';
import './modules/auth-ui.js';
import './modules/init-auth.js';

// Import subscription system
import { initializeSubscription } from './modules/subscription.js';

// Import plant authentication system
import { initializePlantAuth } from './modules/plant-auth.js';

// Import download premium system
import { initializeDownloadPremium } from './modules/download-premium.js';

// Import core functionality modules
import { initializeContainer } from './modules/containerFunctions.js';
import { initializeZones } from './modules/zones.js';
import { initializeSidebar } from './modules/sideBar.js';
import { initializeToggleControls } from './modules/toggleControls.js';
import { initializeGardenLayout } from './modules/garden-layout-image.js';
import { initializeSaveToJournal } from './modules/save-to-journal.js';
import { initializeGardenElements } from './modules/garden-elements.js';
import { initializePlantShade } from './modules/plantShade.js';
import { initializePestSuggestions } from './modules/pestSuggestions.js';
import { initializeBackToTop } from './modules/back-to-top.js';
import { initializeBugReport } from './modules/bug-report.js';
import { initializeShare } from './modules/share.js';
import { initNavigation } from './modules/navigation.js';
import { initializeMobileOverlay } from './modules/mobile-overlay.js';
import { initializeNonPremiumOnboarding } from './modules/nonPremiumOnboarding.js';

// Plant database is loaded on demand via plantDatabaseLoader.js
import './modules/pestRepellentPlants.js';
import { getPlantDatabase } from './modules/plantDatabaseLoader.js';

// Import calendar functionality
import { updateGardenCalendar } from './scripts/calendar.js';

// Initialize the application when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    console.log('🌱 Garden Planner initializing...');
    
    // Initialize mobile overlay first (before other modules)
    initializeMobileOverlay();
    
    // Initialize all modules
    initializeContainer();
    initializeZones();
    initializeSidebar();
    initializeToggleControls();
    initializeGardenLayout();
    initializeSaveToJournal();
    initializeGardenElements();
    initializePlantShade();
    initializePestSuggestions();
    initializeBackToTop();
    initializeBugReport();
    initializeShare();
    initNavigation();
    
    // Initialize subscription system first
    initializeSubscription();
    initializeNonPremiumOnboarding();
    
    // Initialize plant authentication system after subscription system
    setTimeout(() => {
        initializePlantAuth();
    }, 100);
    
    // Initialize download premium system after subscription system
    setTimeout(() => {
        initializeDownloadPremium();
    }, 150);
    
    // Initial calendar render (async; loads plant DB when needed)
    updateGardenCalendar();

    // Preload plant database in background so companion/shade/pest/calendar feel instant
    getPlantDatabase().catch(() => {});

    // Set up MutationObserver to update calendar when grid changes (debounced to avoid repeated work)
    const grid = document.getElementById('grid');
    if (grid) {
        let calendarUpdateScheduled = null;
        const observer = new MutationObserver(() => {
            if (calendarUpdateScheduled) clearTimeout(calendarUpdateScheduled);
            calendarUpdateScheduled = setTimeout(() => {
                calendarUpdateScheduled = null;
                updateGardenCalendar();
            }, 200);
        });
        observer.observe(grid, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style']
        });
    }
    
    console.log('✅ Garden Planner initialized successfully!');
}); 